import {RoomEquipment} from '@lib/store';
import {constructFilter} from './constructFilter';
import {TFunction} from 'i18next';

export const SECTION_ID_ROOM_EQUIPEMENT = 'SECTION_ID_ROOM_EQUIPEMENT';

export const constructRoomEquipementFilter = <TEntity extends {equipment: RoomEquipment[]}>(
  equipment: RoomEquipment[],
  getIconName: (id: RoomEquipment) => string,
  t: TFunction,
) => {
  return constructFilter({
    sectionId: SECTION_ID_ROOM_EQUIPEMENT,
    sectionTitle: t('meeting:EquipmentTitle'),
    type: 'and',
    data: equipment.map((id) => ({
      id,
      label: t(`meetingEquipment:${id}`),
      iconName: getIconName(id),
    })),
    defaultFilterOptions: [],
    predicate: (filter, entity: TEntity) => entity.equipment.includes(filter.id),
  });
};
